import { Ol } from '../../lib/types/models/ol/ol'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getOl(id: number) {
  return restApiClient.url(constructApiUrl(API.ols.get.url, { id })).get<Ol>()
}
